import React, { useState, useEffect } from 'react'
import { useWindowSize } from 'global'
import { IQuestionProps } from './Question'
import { Heading, Box, Flex, QuestionSlider } from 'components'

const INITIAL_PERCENTAGE = 50

const labelIndex = (result: number) => {
  if (result < 33.33) {
    return 0
  } else if (result > 33.33 && result < 66.66) {
    return 1
  } else {
    return 2
  }
}

const QuestionRange = ({ question, onChange }: IQuestionProps) => {
  const { width: windowWidth } = useWindowSize()
  const colorAccent = question.theming ? question.theming.accent : 'light'
  const sliderLabels = React.useCallback(
    () => question.options.map((o) => o.value),
    [question]
  )
  const [activeLabel, setActiveLabel] = useState(0)
  const [sliderPercentage, setSliderPercentage] = useState(INITIAL_PERCENTAGE)
  const [vertical, setVertical] = useState<boolean>()
  const [showSlider, setShowSlider] = React.useState(false)

  const onSliderChange = React.useCallback(
    (result: number) => {
      const activeLabelIdx = labelIndex(result)
      setActiveLabel(activeLabelIdx)
      setSliderPercentage(result)
      onChange([{ label: sliderLabels()[activeLabelIdx], value: result }])
    },
    [sliderLabels, setActiveLabel, setSliderPercentage, onChange]
  )

  const onSliderClick = (index: number) => {
    if (index === 0) {
      setSliderPercentage(0)
      setActiveLabel(0)
    } else if (index === 1) {
      setSliderPercentage(50)
      setActiveLabel(1)
    } else if (index === 2) {
      setSliderPercentage(100)
      setActiveLabel(2)
    }
  }

  useEffect(() => {
    setVertical(!windowWidth || windowWidth < 768)
  }, [windowWidth])

  useEffect(() => {
    setShowSlider(typeof vertical !== undefined)
  }, [vertical])

  useEffect(() => {
    onSliderChange(INITIAL_PERCENTAGE)
  }, [onSliderChange])

  return (
    <Flex width={1} flexDirection='column' justifyContent={['end', 'center']}>
      <Box
        width={1}
        marginBottom={[2, 3]}
        marginLeft={[1]}
        textAlign={['left', null, 'center']}
      >
        <Heading
          uiColorTheme={colorAccent}
          fontSize={['1.6em', '1.8em', '2.2em', '2.4em']}
          as='h2'
          paddingRight={[1, 2]}
          lineHeight='1.25'
          mb={[0, 0, 4, 4]}
        >
          {question.question}
        </Heading>
      </Box>
      <Flex width={1} height='100%' justifyContent='center' alignItems='center'>
        <Flex
          maxWidth='480px'
          width={1}
          flexDirection='column'
          alignItems='center'
        >
          {showSlider && (
            <QuestionSlider
              onChange={onSliderChange}
              onClick={onSliderClick}
              vertical={vertical as boolean}
              sliderLabels={sliderLabels()}
              selectedIndex={activeLabel}
              sliderPercentage={sliderPercentage}
            />
          )}
        </Flex>
      </Flex>
    </Flex>
  )
}

export default QuestionRange
